export default "/_next/static/images/49a19725c744506b3a88401e9afa8755.png";